import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  Tab,
  Tabs,
} from "@mui/material";
import DMBPromosPreSellBoardConfiguration from "./DMBPromosPreSellBoardConfiguration";
import PropTypes from "prop-types";
import FlavorTabShimmer from "./FlavorTabShimmer";
import AWS from "aws-sdk";
import DMBPreSellBoardsList from "./DMBPreSellBoardsList";
import { DMB_TOUR_STEPS } from "../utils/tourConstants";
import { continuousTour, runTour, showTourProgress, updateSteps } from "../redux/userOnboarding/userOnboardingSlice";
import EditSettings from "./EditSettings";
import { Lock, LockOpen, Refresh } from "@mui/icons-material";
import { lockWakeState, releaseWakeState } from "../utils/wakeLock";
import { cacheBoardImage, getCachedBoardImage } from "../utils/boardImageCache";
// Websocket imports
// import useWebSocket, { ReadyState } from "react-use-websocket";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Stores that get the image caching / offline support / live streaming board behavior.
// All other stores keep the original board behavior.
const DMB_ENHANCED_STORES = ["491", "1498", "1512", "1656", "1637", "1640", "1638", "1639"];

const BoardAdministration = () => {
  const { storage, userOnboarding, profile } = useSelector((state) => state);
  const isEnhancedStore = DMB_ENHANCED_STORES.includes(String(storage?.store?.intRitasStoreID));

  const itemlist = [
    { id: 1, title: "menuboard1", image: "", label: "Left Board",show:true, className: 'left-board-tab-tour-selector' },
    { id: 2, title: "menuboard2", image: "", label: "Right Board",show:true, className: 'right-board-tab-tour-selector' },
    {
      id: 3,
      title: "horizontal-flavorboard",
      image: "",
      label: "Horizontal Flavor Board",
      show:true,
      className: 'horizontal-board-tab-tour-selector'
    },
    {
      id: 4,
      title: "vertical-flavorboard",
      image: "",
      label: "Vertical Flavor Board",
      show:true,
      className: 'vertical-board-tab-tour-selector'
    },
    {
      id: 5,
      title: "dmb-presell-board",
      image: "",
      label: "Presell Board",
      show:true,
      className: 'presell-board-tab-tour-selector'
    },
    {
      id: 6,
      title: "dmb-promos",
      image: "",
      label: "DMB Promos",
      show: true,
      className: 'dmbpromos-board-tab-tour-selector'
    }
  ];
  const [value, setValue] = useState(0);
  const [store, setStore] = useState(null);
  const [itemData, setItemData] = useState(itemlist);
  const dispatch = useDispatch();
  const data = useSelector((state) => state);
  const [loading, setLoading] = React.useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [noimage, setNoImage] = useState("");
  const [image, setImage] = useState("");
  const [imgName, setImgName] = useState("");

  const [imageRefreshing, setImageRefreshing] = useState(false);
  const [showRefreshButton, setShowRefreshButton] = useState(false);
  const [isFullScreenView, setIsFullScreenView] = useState(false);
  const [showSettings,setShowSettings]=useState(false)
  const [imageBlob, setImageBlob] = useState(null);
  const [isOffline, setIsOffline] = useState(false);
  const objectUrlRef = useRef(null);

  useEffect(() => {
    setStore(storage?.store);
      setValue(0);
    downloadImages(storage?.store?.intRitasStoreID, 0);
  }, [storage?.store]);

  useEffect(() => {
    if(storage?.store && !imageLoading) {
      // const boardImgElement = document.getElementById('board-image');
      // console.log('fullscreenchange boardImgElement ', boardImgElement );
      
    }
  }, [storage?.store, imageLoading]);

  useEffect(() => {
    if(data?.profile){
      setNoImage("");
      setImgName("");
      setValue(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.profile]);
  
  //Tour Hook 
  useEffect( () => {
    if (!userOnboarding?.tourStatus?.digitalMenuBoard && store){
      const tabIndexVal = DMB_TOUR_STEPS[userOnboarding?.stepIndex]?.tabIndex;
      (tabIndexVal >= 0) && handleChange({target: {}}, tabIndexVal);
       startDigitalMenuBoardTour();
    }
    else handleChange({target: {}}, value);
  }, [store, userOnboarding?.tourStatus?.digitalMenuBoard, userOnboarding?.stepIndex])

  const startDigitalMenuBoardTour = () => {
    dispatch(updateSteps(DMB_TOUR_STEPS));
    dispatch(continuousTour());
    dispatch(showTourProgress());
    dispatch(runTour("digitalMenuBoard"));
  }

  // // DMB Websocket Code starts
  // //Public API that will echo messages sent to it back to the client
  // const [socketUrl, setSocketUrl] = useState('wss://mj9szv63y3.execute-api.us-east-1.amazonaws.com/production/');
  // const [imageUpdatedAt, setImageUpdatedAt] = useState("");

  // const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl, {
  //   // shouldReconnect: (CloseEvent) => true,
  //   queryParams: {
  //     storeId: storage?.store?.intRitasStoreID,
  //     username: profile?.user_name,
  //     userAgent: `${navigator.userAgent}`,
  //     // screens: config.screens,
  //   },
  //   onError: (e) => {
  //     console.log('WebSocket Error: ', e);
  //   }
  // });

  // useEffect(() => {
  //   if (imageUpdatedAt) {
  //     console.log('imageUpdatedAt ', imageUpdatedAt);
  //     handleBoardRefresh(storage?.store?.intRitasStoreID, value);
  //   }
  // }, [imageUpdatedAt]);

  // useEffect(() => {
  //   if (lastMessage !== null) {
  //     console.log('lastMessage ', JSON.parse(lastMessage.data));
  //     const response = JSON.parse(lastMessage.data);
  //     if (response?.lastUpdatedAt)
  //       setImageUpdatedAt(response?.lastUpdatedAt);
  //   }
  // }, [lastMessage]);

  // const connectionStatus = {
  //   [ReadyState.CONNECTING]: 'Connecting',
  //   [ReadyState.OPEN]: 'Open',
  //   [ReadyState.CLOSING]: 'Closing',
  //   [ReadyState.CLOSED]: 'Closed',
  //   [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
  // }[readyState];

  // console.log('WS connectionStatus ', connectionStatus, lastMessage, `${navigator.userAgent}`);

  // // DMB Websocket Code Ends

  // Fetches the board image and caches it locally on success; if the
  // request fails (e.g. no internet), falls back to the last cached image
  // for this store/board instead of showing a blank "not configured" state.
  // Caching happens as part of the same request used to display the image,
  // so there's no window where the image shows but hasn't been cached yet.
  const loadBoardImage = async (ritasStoreID, index, { isRefresh = false } = {}) => {
    if (!ritasStoreID) return;
    const boardTitle = itemlist[index].title;
    const effectiveStoreID = !userOnboarding?.tourStatus?.digitalMenuBoard ? 0 : ritasStoreID;
    const cacheKey = `${ritasStoreID}_${boardTitle}`;
    const url = `https://${process.env.REACT_APP_AWS_BUCKET}.s3.amazonaws.com/${process.env.REACT_APP_DMB_END_POINT_IMAGES}/${effectiveStoreID}/${boardTitle}-${effectiveStoreID}-1920.jpg?rand=${Math.floor(Math.random() * 5557654)}`;

    setNoImage("");
    setImgName(boardTitle);
    isRefresh ? setImageRefreshing(true) : setImageLoading(true);

    let blob = null;
    let usedCache = false;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
      blob = await response.blob();
      cacheBoardImage(cacheKey, blob);
    } catch (err) {
      blob = await getCachedBoardImage(cacheKey);
      usedCache = !!blob;
    }

    if (blob) {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
      const objectUrl = URL.createObjectURL(blob);
      objectUrlRef.current = objectUrl;
      setImageBlob(blob);
      setImage(objectUrl);
      setNoImage("SUCCESS");
      setIsOffline(usedCache);
    } else {
      setImageBlob(null);
      setImage("");
      setNoImage("FAILURE");
      setIsOffline(false);
    }

    setTimeout(() => (isRefresh ? setImageRefreshing(false) : setImageLoading(false)), 399);
  };

  const downloadImages = (ritasStoreID, index = 0) => {
    if (isEnhancedStore) {
      loadBoardImage(ritasStoreID, index);
      return;
    }
    setNoImage("");
    setImageLoading(true);
    if (ritasStoreID) {
      var url = `https://${process.env.REACT_APP_AWS_BUCKET}.s3.amazonaws.com/${process.env.REACT_APP_DMB_END_POINT_IMAGES}/${!userOnboarding?.tourStatus?.digitalMenuBoard ? 0 : ritasStoreID}/${itemlist[index].title}-${!userOnboarding?.tourStatus?.digitalMenuBoard ? 0 : ritasStoreID}-1920.jpg?rand=${Math.floor(Math.random() * 5557654)}`
      if (url) {
        setImage(url);
        setImgName(itemlist[index].title);
        setTimeout(() => setImageLoading(false), 399);
      }
    }
  };


  const handleFullScreen = () => {
    if (isEnhancedStore) {
      if (image) window.open(image, "_blank");
      return;
    }
    let urlObject = new URL(image);
    urlObject.searchParams.delete('rand');
    const modifiedUrl = urlObject.toString();
    window.open(modifiedUrl, "_blank");
  };


  const handleChange = (event, newValue) => {
    setValue(newValue);
    setImgName(event.target.textContent);
    setImage("");
    downloadImages(storage?.store?.intRitasStoreID, newValue);
  };
  
  const downloadBlob = (blob, ImageName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', ImageName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const download = (ImageName) => {
    if (isEnhancedStore) {
      if (imageBlob) downloadBlob(imageBlob, ImageName);
      return;
    }
    const imagePath=`${image}?rand=${Math.floor(Math.random() * 5557654)}`
    fetch(imagePath)
        .then(response => response.blob())
        .then(blob => downloadBlob(blob, ImageName))
        .catch(error => {
            console.error('Error downloading image:', error);
        });
  };

  const imageOnLoad = (event) => {
    if (event.currentTarget.className !== "error") {
      event.currentTarget.className = "success";
      setNoImage("SUCCESS");
    }
  };
  const imageOnError = (event) => {
    event.currentTarget.src = "../assets/images/noimage.jpg";
    event.currentTarget.className = "error";
    setNoImage("FAILURE");
  };

  const handleEditSettings = () => {
    setShowSettings(!showSettings)
  }

  useEffect(() => {
    if (document.addEventListener) {
      document.addEventListener('fullscreenchange', exitHandler, false);
      document.addEventListener('mozfullscreenchange', exitHandler, false);
      document.addEventListener('MSFullscreenChange', exitHandler, false);
      document.addEventListener('webkitfullscreenchange', exitHandler, false);
    }
    return () => {
      document.removeEventListener('fullscreenchange', exitHandler, false);
      document.removeEventListener('mozfullscreenchange', exitHandler, false);
      document.removeEventListener('MSFullscreenChange', exitHandler, false);
      document.removeEventListener('webkitfullscreenchange', exitHandler, false);
    };
  }, []);

  const exitHandler = () => {
    if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      setIsFullScreenView(false);
      setShowRefreshButton(false);
      releaseWakeState();
    }
  }

  const handleFullScreenView = () => {
    const elem = document.getElementById('board-image');
    if (elem.requestFullscreen) elem.requestFullscreen();
    else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen(); /* Safari */
    else if (elem.msRequestFullscreen) elem.msRequestFullscreen(); /* IE11 */
    setIsFullScreenView(true);
    setShowRefreshButton(true);
    lockWakeState();
  }

  const handleBoardRefresh = (ritasStoreID, index) => {
    if (isEnhancedStore) {
      loadBoardImage(ritasStoreID, index, { isRefresh: true });
      return;
    }
    if (ritasStoreID) {
      setImageRefreshing(true);
      var url = `https://${process.env.REACT_APP_AWS_BUCKET}.s3.amazonaws.com/${process.env.REACT_APP_DMB_END_POINT_IMAGES}/${!userOnboarding?.tourStatus?.digitalMenuBoard ? 0 : ritasStoreID}/${itemlist[index].title}-${!userOnboarding?.tourStatus?.digitalMenuBoard ? 0 : ritasStoreID}-1920.jpg?rand=${Math.floor(Math.random() * 5557654)}`
      if (url) {
        setImage(url);
        setImgName(itemlist[index].title);
        setTimeout(() => setImageRefreshing(false), 399);
      }
    }
  }

  // While the board is in fullscreen, keep pulling a fresh image every 5 minutes
  // so flavor/menu changes show up without someone manually hitting Refresh.
  useEffect(() => {
    if (!isEnhancedStore || !isFullScreenView || !storage?.store?.intRitasStoreID) return;
    const intervalId = setInterval(() => {
      handleBoardRefresh(storage?.store?.intRitasStoreID, value);
    }, 1 * 60 * 1000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFullScreenView, storage?.store?.intRitasStoreID, value]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col">
              <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Digital Menu Board
              </h1>
              <small className="pt-2" style={{color:"#D41D49"}}><b>Note:</b> It may take up to 2-5 minutes for the menu board image to update with flavor changes. Please <strong> refresh </strong> your browser as this does not automatically <strong> refresh </strong> when Flavor Portal is updated. </small>
            </div>
            <div className="flex justify-end">
            <button
              style={{ height: "38px", width: '120px' }}
              type="button"
              onClick={() => handleEditSettings()}
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
            >
              Edit Settings
            </button>
            </div>
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 py-8">
            <div className="rounded-md bg-white shadow-md">
              <>
                {storage?.store && Object.keys(storage?.store).length ? (
                  <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs value={value} onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        classes={{ scroller: userOnboarding?.tourStatus?.digitalMenuBoard ? "" : "!overflow-hidden" }}
                      >
                        {itemData?.filter(i=>i?.show)?.map((itm, index) => (
                          <Tab
                            className={itm.className}
                            label={itm.label}
                            {...a11yProps(itm.id)}
                            key={itm.id}
                          />
                        ))}
                      </Tabs>
                    </Box>
                    {itemData?.filter(i=>i?.show)?.map((category, categoryIndex) => {
                      return (
                        <TabPanel
                          key={category.id}
                          value={value}
                          index={categoryIndex}
                        >
                          {category.id === 5 ?(
                            <DMBPreSellBoardsList store={store} />
                          ):(category.id == 6) ? <DMBPromosPreSellBoardConfiguration
                                                        intStoreID={store?.intStoreID}
                                                      /> :(<>
                          {imageLoading ? (
                            <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                            </div>
                          ) : (
                            <Card justify="center" alignItems="center">
                              {noimage !== "" && noimage !== "FAILURE" && (
                                <CardContent
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    onClick={() => download(`${imgName}.jpg`)}
                                    className="flash-drive-tour-selector"
                                  >
                                    USB Flash Drive
                                  </Button>
                                  {isEnhancedStore ? (
                                    <Button
                                      variant="outlined"
                                      onClick={() => handleFullScreenView()}
                                      className="streaming-tour-selector"
                                    >
                                      Live Streaming
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      onClick={() => handleFullScreen()}
                                      className="streaming-tour-selector"
                                    >
                                      Streaming
                                    </Button>
                                  )}
                                </CardContent>
                              )}
                              {noimage === "SUCCESS" && isOffline && (
                                <div className="text-center text-sm py-1" style={{ color: "#D41D49" }}>
                                  You're offline. Showing the last synced menu board image.
                                </div>
                              )}
                              <div id='board-image' className="relative">
                                {(isFullScreenView && showRefreshButton) && <IconButton size="small" className="m-3 absolute right-0 text-white bg-gray-500 bg-opacity-50" onClick={() => handleBoardRefresh(storage?.store?.intRitasStoreID, value)}><Refresh /></IconButton>}
                                {imageRefreshing && <Backdrop
                                  sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                  open={imageRefreshing}
                                >
                                  <CircularProgress color="inherit" />
                                </Backdrop>}
                                <img
                                  src={image}
                                  {...(!isEnhancedStore && { onLoad: imageOnLoad, onError: imageOnError })}
                                  style={{ minHeight: "320px", margin: "auto" }}
                                  alt="drive board"
                                  onClick={() => setShowRefreshButton(!showRefreshButton)}
                                />
                              </div>
                              {noimage !== "" && noimage === "FAILURE" && (
                                <CardContent>
                                  <div
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    Menu Boards are not configured this shop. Please contact your Franchise Consultant for assistance.
                                  </div>
                                </CardContent>
                              )}
                              
                              {/* <small className="m-2" style={{color:"#D41D49"}}><b>Note:</b> USB-Storage drive is deprecated.Please contact your Franchise Consultant for assistance</small> */}
                            </Card>
                          )}
                          </>)}
                        </TabPanel>
                      );
                    })}
                  </Box>
                ) : (
                  <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                    Please select a store
                  </div>
                )}
              </>
            </div>
          </div>
        </main>
      </div>
      {showSettings && <EditSettings handleEditSettings={handleEditSettings} store={storage?.store} />}
    </>
  );
};

export default BoardAdministration;
